import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import MetaTags from "react-meta-tags";
import { withRouter, Link } from "react-router-dom";
import { Tooltip } from "@material-ui/core";
import { Card, CardBody, Col, Container, Row, Button } from "reactstrap";
import { isEmpty, sample } from "lodash";
import moment from "moment";
import BootstrapTable from "react-bootstrap-table-next";
// import { Bar } from "react-chartjs-2";
import "assets/scss/table.scss";
import { getSchemeAnalytesList } from "store/results/actions";
import { getReport, getSereologyResult } from "store/resultsSubmit/actions";
import "assets/scss/table.scss";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import logo from "../../assets/images/neqas-logo.jpeg";

class Results extends Component {
  constructor(props) {
    super(props);
    this.node = React.createRef();
    this.state = {
      SchemeAnalytesList: [],
      Report: [],
      SerologyResult: [],
      zScoresData: {}, // Store the fetched z-scores data
      combinedData: [], // Store the combined data here
      totalScore: "",
      possibleScore: "",
      accuracy: 0,
      // analyte: "",
      // rounds: [],
      user_id: localStorage.getItem("authUser")
        ? JSON.parse(localStorage.getItem("authUser")).user_id
        : "",
      columnsList: [
        {
          text: "Analyte",
          dataField: "name",
          sort: true,
          headerClasses: "text-center", // Center header text
          classes: "text-center", // Center cell text
          formatter: (cellContent, analyte) => (
            <div className="text-center">{analyte.name}</div>
          ),
        },
        {
          text: "Instrument",
          sort: true,
          headerClasses: "text-center",
          classes: "text-center",
          formatter: (cellContent, analyte) => (
            <div className="text-center">{analyte.instrument}</div>
          ),
        },
        {
          text: "No of Participants",
          headerClasses: "text-center",
          classes: "text-center",
          formatter: (cellContent, analyte) =>
            analyte.qualitative_result_type &&
            analyte.qualitative_result_type !== "Not Submitted" ? (
              <div className="text-center">{analyte.lab_count}</div>
            ) : (
              <div className="text-center">--</div>
            ),
        },

        {
          text: "Your Result",
          headerClasses: "text-center",
          classes: "text-center",
          formatter: (cellContent, analyte) => (
            <div className="text-center">
              {analyte.qualitative_result_type &&
              analyte.qualitative_result_type !== "Not Submitted"
                ? analyte.result_value
                : "Not Submitted"}
            </div>
          ),
        },

        {
          text: "Expected Result",
          headerClasses: "text-center",
          classes: "text-center",
          formatter: (cellContent, analyte) =>
            analyte.qualitative_result_type &&
            analyte.qualitative_result_type !== "Not Submitted" ? (
              <div className="text-center">
                {analyte.true_value && typeof analyte.true_value === "string"
                  ? analyte.true_value.charAt(0).toUpperCase() +
                    analyte.true_value.slice(1).toLowerCase()
                  : analyte.true_value || "N/A"}
              </div>
            ) : (
              <div className="text-center">--</div>
            ),
        },

        {
          text: "Score",
          headerClasses: "text-center",
          classes: "text-center",
          formatter: (cellContent, analyte) => (
            <div className="text-center">{analyte.score}</div>
          ),
        },
      ],
    };
  }

  combineData = (analytes, report, serologyResults) => {
    const analyteResultSummary =
      this.props.Report?.analyte_result_summary || [];
    const graphData = this.props.Report?.graph_data || [];

    let totalScore = 0;
    let possibleScore = 0;

    const combinedData = analytes.map(analyte => {
      const resultEntry = report.find(
        result =>
          Number(result?.analyte_id) === Number(analyte.id) &&
          Number(result?.participant_id) === Number(this.props.match.params.id1)
      );

      const summaryEntry = analyteResultSummary.find(
        summary => Number(summary.analyte_id) === Number(analyte.id)
      );

      const graphEntry = graphData.find(
        g => Number(g.analyte_id) === Number(analyte.id)
      );

      const qualitativeSubmitted =
        resultEntry?.qualitative_result_type &&
        resultEntry.qualitative_result_type !== "Not Submitted";

      const result_value = qualitativeSubmitted
        ? resultEntry.qualitative_result_type
        : "Not Submitted";

      const labCount = qualitativeSubmitted
        ? graphEntry?.lab_count ??
          summaryEntry?.lab_count ??
          resultEntry?.lab_count ??
          0
        : null;

      const expectedResult = qualitativeSubmitted
        ? resultEntry?.true_value ?? resultEntry?.expected_result ?? "N/A"
        : null;

      const score = qualitativeSubmitted ? resultEntry?.score || 0 : 0;

      // ✅ Only count submitted analytes toward possible score
      if (qualitativeSubmitted) {
        possibleScore += 5;
        totalScore += score;
      }

      return {
        ...analyte,
        lab_count: labCount,
        instrument: resultEntry?.instrument || "",
        qualitative_result_type: resultEntry?.qualitative_result_type ?? null,
        result_value,
        score,
        true_value: expectedResult,
      };
    });
    const sortedData = combinedData.sort((a, b) =>
      a.name.localeCompare(b.name)
    );
    const accuracy = possibleScore ? (totalScore / possibleScore) * 100 : 0;

    return { combinedData, sortedData, totalScore, possibleScore, accuracy };
  };

  componentDidMount() {
    console.log("userid", this.state.user_id);
    const { onGetSchemeAnalyte, onGetReport, onGetSereologyResult } =
      this.props;

    const id = this.props.match.params.id;
    const roundId = this.props.match.params.id; // ✅ round id
    const labId = this.props.match.params.id1; // ✅ lab id (participant id)
    onGetSchemeAnalyte(id);
    onGetReport(roundId, labId);
    onGetSereologyResult(id);
  }

  componentDidUpdate(prevProps) {
    const { SchemeAnalytesList, Report, SerologyResult } = this.props;

    if (
      (SchemeAnalytesList !== prevProps.SchemeAnalytesList ||
        Report !== prevProps.Report ||
        SerologyResult !== prevProps.SerologyResult) &&
      !isEmpty(SchemeAnalytesList) &&
      !isEmpty(Report) &&
      !isEmpty(SerologyResult)
    ) {
      console.log("🔍 SchemeAnalytesList:", SchemeAnalytesList);
      console.log("📄 Report from API:", Report);
      console.log("🧪 SerologyResult:", SerologyResult);
      const { combinedData, totalScore, possibleScore, accuracy } =
        this.combineData(
          SchemeAnalytesList,
          Report.participants_results || [], // ✅ Use actual array
          SerologyResult
        );

      if (
        JSON.stringify(combinedData) !== JSON.stringify(this.state.combinedData)
      ) {
        this.setState({ combinedData, totalScore, possibleScore, accuracy });
      }
    }
  }

  handleDownloadPDF = () => {
    const input = document.getElementById("report-area");
    const downloadBtn = input.querySelector(".no-print"); // ✅ target button

    if (downloadBtn) downloadBtn.style.display = "none"; // hide before capture
    html2canvas(input, {
      scale: 2,
      useCORS: true, // 👈 allow cross-origin images
      allowTaint: true, // 👈 helps capture remote images
    }).then(canvas => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");

      const imgWidth = 210;
      const pageHeight = 295;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      let heightLeft = imgHeight;
      let position = 0;

      pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      while (heightLeft > 0) {
        position = position - pageHeight;
        pdf.addPage();
        pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }

      if (downloadBtn) downloadBtn.style.display = "block";
      pdf.save("Participant-results-report.pdf");
    });
  };

  render() {
    const { rounds, issue_date, closing_date, participant_name } = this.props;
    const { combinedData, totalScore, possibleScore, accuracy } = this.state;
    // Count total analytes and submitted results
    const totalAnalytes = combinedData.length; // Total number of analytes
    const submittedResultsCount = combinedData.filter(
      analyte =>
        analyte.qualitative_result_type &&
        analyte.qualitative_result_type !== "Not Submitted"
    ).length;
    const participant_id = this.props.match.params.id1;
    const defaultSorted = [
      {
        dataField: "analyte_name",
        order: "asc",
      },
    ];

    return (
      <React.Fragment>
        <Container
          id="report-area" // ✅ added
          fluid
          style={{
            paddingTop: "10%",
            paddingBottom: "10%",
            paddingLeft: "10%",
            paddingRight: "10%",
          }}
        >
          <div className="d-flex justify-content-end mb-3">
            <Button
              className="w-25 no-print btn btn-outline-secondary"
              onClick={this.handleDownloadPDF}
            >
              Download
            </Button>
          </div>

          <style>
            {`@media print {
              .no-print { display: none !important; }
              /* General print settings */
              body {
                font-size: 12px;
                line-height: 1.4;
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
              }

              /* Hide unwanted elements */
              .navbar, .footer, .breadcrumb {
                display: none !important;
              }

              /* First page margins */
              @page :first {
                size: A4;
                margin: 20mm 20mm 20mm 20mm; /* top, right, bottom, left */
              }

              /* Margins for subsequent pages */
              @page {
                size: A4;
                margin: 80mm 20mm 20mm 20mm; /* bigger top margin for subsequent pages */
              }
              /* Optional: Table styling for print */
              table {
                width: 100% !important;
                border: 1px solid #dee2e6;
                border-collapse: collapse;
              }

              th, td {
                padding: 8px;
                text-align: left;
              }

              /* Report header */
              .report-header {
                display: block !important;
              }

              .report-header h4, .report-header h6 {
                font-size: 12px;
              }
              .print-content {
                display: block;
                page-break-inside: auto;
                padding-top: 10mm; /* adds space for subsequent pages */
              }
            }

            .table thead th {
              background-color: #6C48C5;
              // background-color: #C68FE6;
              color: white; /* White text for contrast */
            }
            .table td {
              text-align: left !important; /* Use this if necessary */
            }
              

            `}
          </style>

          {/* Report Header */}
          <div className="report-header my-4">
            <div className="text-center mb-3">
              <img
                src="https://externalqcapi.com/media/organization/nhs_logo.webp"
                alt="Logo"
                style={{ height: "60px", marginBottom: "10px" }}
              />

              <h4 style={{ fontWeight: "bold", color: "blue" }}>
                NHS - National External Quality Assessment Scheme
              </h4>
            </div>
            <Row>
              <Row>
                {/* Left Column */}
                <Col md={6}>
                  <Row className="mb-2">
                    <Col
                      xs={6}
                      className="text-end"
                      style={{ fontWeight: "bold", color: "black" }}
                    >
                      Participant Number:
                    </Col>
                    <Col xs={6} className="text-left" style={{ color: "blue" }}>
                      {this.props.Report?.participant_name || "No name found"}
                    </Col>
                  </Row>
                  <Row className="mb-2">
                    <Col
                      xs={6}
                      className="text-end"
                      style={{ fontWeight: "bold", color: "black" }}
                    >
                      Issue Date:
                    </Col>
                    <Col xs={6} className="text-left" style={{ color: "blue" }}>
                      {moment(issue_date).format("DD-MMM-YY")}
                    </Col>
                  </Row>
                  <Row className="mb-2">
                    <Col
                      xs={6}
                      className="text-end"
                      style={{ fontWeight: "bold", color: "black" }}
                    >
                      Closing Date:
                    </Col>
                    <Col xs={6} className="text-left" style={{ color: "blue" }}>
                      {moment(closing_date).format("DD-MMM-YY")}
                    </Col>
                  </Row>
                  <Row className="mb-2">
                    <Col
                      xs={6}
                      className="text-end"
                      style={{ fontWeight: "bold", color: "black" }}
                    >
                      Print Date:
                    </Col>
                    <Col xs={6} className="text-left" style={{ color: "blue" }}>
                      {moment(new Date()).format("DD-MMM-YY")}
                    </Col>
                  </Row>
                </Col>

                {/* Right Column */}
                <Col md={6}>
                  <Row className="mb-2">
                    <Col
                      xs={6}
                      className="text-end"
                      style={{ fontWeight: "bold", color: "black" }}
                    >
                      Scheme:
                    </Col>
                    <Col xs={6} className="text-left" style={{ color: "blue" }}>
                      {this.props.Report?.scheme_name || "--"}
                    </Col>
                  </Row>
                  <Row className="mb-2">
                    <Col
                      xs={6}
                      className="text-end"
                      style={{ fontWeight: "bold", color: "black" }}
                    >
                      Cycle:
                    </Col>
                    <Col xs={6} className="text-left" style={{ color: "blue" }}>
                      {this.props.Report?.cycle_no || "--"}
                    </Col>
                  </Row>
                  <Row className="mb-2">
                    <Col
                      xs={6}
                      className="text-end"
                      style={{ fontWeight: "bold", color: "black" }}
                    >
                      Round:
                    </Col>
                    <Col xs={6} className="text-left" style={{ color: "blue" }}>
                      {rounds ? rounds : "N/A"}
                    </Col>
                  </Row>
                  <Row className="mb-2">
                    <Col
                      xs={6}
                      className="text-end"
                      style={{ fontWeight: "bold", color: "black" }}
                    >
                      Sample:
                    </Col>
                    <Col xs={6} className="text-left" style={{ color: "blue" }}>
                      {this.props.sample}
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Row>
          </div>
          <div className="page-contant">
            <Container fluid>
              <Row className="justify-content-center align-item-center">
                <Col lg="10">
                  <Card>
                    <CardBody>
                      <div className="table-responsive">
                        <BootstrapTable
                          id="printable-table"
                          keyField="id"
                          ref={this.node}
                          responsive
                          bordered={false}
                          striped={false}
                          defaultSorted={defaultSorted}
                          classes={
                            "table table-bordered table-hover table-striped table-primary"
                          }
                          data={combinedData}
                          columns={this.state.columnsList}
                          // Remove pagination-related props
                        />
                      </div>
                      {/* Add the note below the table */}
                      <div className="mt-3" style={{ color: "#6C48C5" }}>
                        You have submitted results for{" "}
                        <strong>{submittedResultsCount}</strong> analytes out of
                        total <strong>{totalAnalytes}</strong> analytes.
                        <div>
                          Your TOTAL SCORE is <strong>{totalScore}</strong> out
                          of a possible score of{" "}
                          <strong>{possibleScore}</strong>
                        </div>
                        <div>
                          Your accuracy is{" "}
                          <strong>{accuracy.toFixed(2)}%</strong>
                        </div>{" "}
                        {/* Display accuracy */}
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Container>
          </div>
        </Container>
      </React.Fragment>
    );
  }
}

Results.propTypes = {
  match: PropTypes.object,
  className: PropTypes.any,

  SchemeAnalytesList: PropTypes.array,
  Report: PropTypes.array,
  SerologyResult: PropTypes.array,

  rounds: PropTypes.number,
  round_id: PropTypes.number,
  sample: PropTypes.string,
  issue_date: PropTypes.string,
  participant_name: PropTypes.string,
  closing_date: PropTypes.string,
  onGetSchemeAnalyte: PropTypes.func,
  onGetReport: PropTypes.func,
  onGetSereologyResult: PropTypes.func,
};

const mapStateToProps = ({ SchemeAnalytesList, ResultSubmit }) => ({
  SchemeAnalytesList: SchemeAnalytesList.SchemeAnalytesList,
  rounds: SchemeAnalytesList.rounds,
  sample: ResultSubmit.Report?.sample || "",
  round_id: SchemeAnalytesList.round_id,
  issue_date: SchemeAnalytesList.issue_date,
  participant_name: ResultSubmit.participant_name,
  closing_date: SchemeAnalytesList.closing_date,
  Report: ResultSubmit.Report, // ✅ important: keep it as an object
  SerologyResult: ResultSubmit.SerologyResult,
});

const mapDispatchToProps = dispatch => ({
  onGetSchemeAnalyte: id => dispatch(getSchemeAnalytesList(id)),
  onGetReport: (roundId, labId) => dispatch(getReport(roundId, labId)),
  onGetSereologyResult: id => dispatch(getSereologyResult(id)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Results));
